module.exports = __webpack_public_path__ + "static/media/comment3_3.99f016d0.png";